import React from 'react';
import GraphImg from 'graphcms-image';

const ImageItem = ({ image }) => {
  return (
    <React.Fragment>
      {image && <GraphImg image={image} maxWidth={1200} />}
    </React.Fragment>
  );
};

export default ImageItem;
